import {
  createStore,
  findMapping,
  type ShellHandle,
  type TenantMapping,
} from "@observe-tech/mfe-shell-api";
import type { AuthApi } from "./auth";

// Baked in by vite.config.ts from the ENVIRONMENT build arg.
declare const __FLAG_ENV__: string | undefined;

export function mappingsUrl(env: string | undefined): string {
  const raw = (env ?? "").trim().toLowerCase();
  const prod = raw === "prod" || raw === "production";
  return `https://akva-kraken-api${prod ? "" : ".staging"}.observe.tech/api/mappings`;
}

export function createMappingsApi(
  auth: Pick<AuthApi, "getToken">,
  url = mappingsUrl(
    typeof __FLAG_ENV__ === "undefined" ? undefined : __FLAG_ENV__,
  ),
): ShellHandle["mappings"] {
  const store = createStore<TenantMapping[]>([]);
  return {
    list: store.store,
    refresh: async () => {
      try {
        const token = await auth.getToken();
        const res = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = (await res.json()) as { getMappings?: TenantMapping[] };
        store.set(body.getMappings ?? []);
      } catch (e) {
        console.warn("[shell] mappings fetch failed", e);
      }
    },
    getMapping: (from, to) => findMapping(store.store.get(), from, to),
  };
}
